import { remove } from "lodash";

const key = "deny-all-feedback";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]+\/security$/);
};

const modify = (resp) => {
	if(resp.data.Success !== true || !resp.data.Data) {
		return;
	}
	
	const assigned = resp.data.Data.Assigned;
	const role = resp.data.Data.Roles.find(r => r.Code === assigned[0].Code);
	remove(role.Actions, a => a.Path.indexOf("feedback") > -1);

	const newDeny = { Effect: "Deny", Path: "/feedback/**/*" };
	role.Actions.push(newDeny);

};

export const  denyAllFeedback = [key, applicable, modify];